import CommunicationStore from './CommunicationStore';

export * from './CommunicationStore.dto';
export default new CommunicationStore();
